import { __awaiter } from "tslib";
import React from 'react';
import moment from 'moment';
import { Progress } from 'react-sweet-progress';
import LabSimService from '../../services/LabSimService';
import { GradeSyncEntryStatus, } from '../../models/IGradeSyncStatus';
import { T } from '@testout/labsim-ui-atomics';
const DEFAULT_SYNC_DISABLE_MINUTES = 10;
export default class SyncHistory extends React.Component {
    constructor(props) {
        super(props);
        this.statusTick = () => __awaiter(this, void 0, void 0, function* () {
            const data = yield LabSimService.syncStatus();
            this.statusCallback(data);
        });
        this.renderSyncHistory = () => {
            var _a;
            const statuses = (_a = this.state.statusData) === null || _a === void 0 ? void 0 : _a.history.map((history) => {
                const submitTime = moment(history.submissionTime);
                const updateTime = moment(history.lastUpdateTime).local();
                const logLink = (React.createElement(T.IconButton, { screenReaderDescription: 'Download log', automationId: 'logLink', iconVariation: T.IconVariation.Download, onClick: () => SyncHistory.onStatusClick(history) }));
                let status = history.status;
                let running = false;
                let className = '';
                if (history.status === GradeSyncEntryStatus.STARTED) {
                    status = history.lastAction;
                    running = true;
                }
                if (history.status === GradeSyncEntryStatus.STARTED ||
                    history.status === GradeSyncEntryStatus.SUBMITTED) {
                    className = 'submitted';
                }
                if (history.status === GradeSyncEntryStatus.FAILED) {
                    className = 'failed';
                }
                if (history.status === GradeSyncEntryStatus.PARTIALLY_COMPLETE) {
                    className = 'failed';
                }
                return (React.createElement("tr", { key: history.rowKey, className: className },
                    React.createElement("td", null, submitTime.format('ddd, MMM DD • LT')),
                    React.createElement("td", null, `${status} (${updateTime.format('ddd, MMM DD • LT')})`),
                    React.createElement("td", { className: 'center' }, history.numUpdates),
                    React.createElement("td", { className: 'center' },
                        running && history.numCourses > 0 && (React.createElement(Progress, { percent: Math.round((history.numCoursesChecked * 100) / history.numCourses), status: 'active', style: { width: '120px' } })),
                        running && history.numSubmissions > 0 && (React.createElement(Progress, { percent: Math.round((history.numSubmissionsChecked * 100) / history.numSubmissions), status: 'active', style: { width: '120px' } })),
                        history.status !== GradeSyncEntryStatus.STARTED &&
                            history.status !== GradeSyncEntryStatus.SUBMITTED &&
                            logLink,
                        history.status === GradeSyncEntryStatus.STARTED ||
                            (history.status === GradeSyncEntryStatus.SUBMITTED && `-`))));
            });
            return statuses;
        };
        this.hasStatusHistory = (statusData) => statusData && statusData.history && statusData.history.length > 0;
        this.state = {
            initialLoading: true,
        };
    }
    componentDidMount() {
        this.statusTick();
    }
    componentWillUnmount() {
        if (this.state.timerId != null)
            clearInterval(this.state.timerId);
    }
    static onStatusClick(history) {
        if (history.requestGuid === undefined) {
            return;
        }
        LabSimService.openSyncLog(history.requestGuid);
    }
    statusCallback(data) {
        this.setState({ statusData: data, initialLoading: false });
        if (this.props.onStatusDataChanged != null) {
            this.props.onStatusDataChanged(data);
        }
        if (data.status !== GradeSyncEntryStatus.SUCCESS || !data.hasIncomplete) {
            if (this.state.timerId != null)
                clearInterval(this.state.timerId);
            this.setState({ timerId: null });
        }
        else if (data.hasIncomplete) {
            if (this.state.timerId == null) {
                const timer = setInterval(this.statusTick, 5000);
                this.setState({ timerId: timer });
            }
        }
        if (data.history && data.history.length > 0) {
            const resyncDisableMinutes = parseInt(process.env.REACT_APP_DISABLE_SYNC_MINUTES) ||
                DEFAULT_SYNC_DISABLE_MINUTES;
            const noResyncBefore = moment().add(0 - resyncDisableMinutes, 'minutes');
            const shouldDisableButton = data.history.filter((h) => moment(h.submissionTime).isAfter(noResyncBefore)).length > 0;
            // set the sync button to be disabled
            this.props.disableSyncCallback(shouldDisableButton);
        }
        else {
            // we don't have history, don't disable the sync button
            this.props.disableSyncCallback(false);
        }
    }
    render() {
        if (this.state.initialLoading) {
            return React.createElement(T.Loading.Inline, null);
        }
        if (this.hasStatusHistory(this.state.statusData)) {
            return (React.createElement("table", null,
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", null, "Requested"),
                        React.createElement("th", null, "Status"),
                        React.createElement("th", { className: 'center' }, "Updates"),
                        React.createElement("th", { className: 'center' }, "Log"))),
                React.createElement("tbody", null, this.renderSyncHistory())));
        }
        return (React.createElement(T.Text.P, { automationId: 'noHistory', variation: T.Text.Variation.Small }, "No previous history"));
    }
}
//# sourceMappingURL=SyncHistory.js.map